import { Button, Col, DatePicker, Form, Row, Typography } from "antd";
import BieuDo from "components/bieuDo";
import FillterTable from "components/FillterTable";
import { PopUpAddGraphical } from "components/popupAddGraphical";
import RenderForm from "components/renderForm";
import TablePagination from "components/TablePagination";
import dayjs from "dayjs";
import { exportTableToExcelNew } from "helpers";
import { ConverDataName } from "helpers/dataToAntdSelect";
import { rangePresets } from "helpers/helpersDatePicker";
import { useEffect, useState } from "react";
import { useQueries } from "react-query";
import { getApiHosts, getApiMethods, getApiNames, getHours, getStatusCodes } from "services/apiRequest";
import { getDataTruyCapAPI, getGraphicalTruyCapApi } from "services/truyCapAPIRequest";

export default function ThongKeTruyCapAPI() {

    const [form] = Form.useForm();

    const [tableFields, setTableFields] = useState({ metricIds: [1, 2], dimensionIds: [1] });

    const [
        { data: dataApiNames }, { data: dataStatusCodes }, { data: dataHours },
        { data: dataApiHosts }, { data: dataApiMethods }] = useQueries([
            {
                queryKey: ["dataApiNames"],
                queryFn: () => getApiNames(),
            },
            {
                queryKey: ["dataStatusCodes"],
                queryFn: () => getStatusCodes(),
            },
            {
                queryKey: ["dataHours"],
                queryFn: () => getHours(),
            },
            {
                queryKey: ["dataApiHosts"],
                queryFn: () => getApiHosts(),
            },
            {
                queryKey: ["dataApiMethods"],
                queryFn: () => getApiMethods(),
            }
        ]);
    const [dataExport, setDataExport] = useState(null);

    const [graphical, setGraphical] = useState(null);
    const setUpFormModal = [
        {
            name: 'range-time',
            type: 'range-picker',
            lg: 6,
            propsInput: {
                format: "DD/MM/YYYY",
                presets: rangePresets
                // showSearch: true,
                // allowClear: true
            },
            label: 'Khoảng thời gian',
        },
        {
            name: 'names',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Tên API',
            options: ConverDataName(dataApiNames?.data || []),
        },
        {
            name: 'statusCodes',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Mã trạng thái',
            options: ConverDataName(dataStatusCodes?.data || []),
        },
        {
            name: 'hours',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Giờ',
            options: ConverDataName(dataHours?.data || []),
        },
        {
            name: 'hosts',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Domain',
            options: ConverDataName(dataApiHosts?.data || []),
        },
        {
            name: 'methods',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Phương thức',
            options: ConverDataName(dataApiMethods?.data || []),
        },
        {
            type: "html",
            lg: 6,
            content: (
                <Row className={"w-full flex gap-x-2 justify-start items-end content-end h-full"}>
                    {/* <Typography.Text>
                        Thời gian cập nhật dữ liệu :12/12/2022
                    </Typography.Text>
                    <Button
                        color="danger"
                    >
                        Cập nhật dữ liệu mới
                    </Button> */}
                    <Button type="primary"
                        onClick={() => {
                            form.submit();
                        }}
                    >Áp dụng</Button>
                </Row>
            ),
        },
    ];

    const [whereCondition, setWhereCondition] = useState({
        startTime: dayjs().subtract(30, 'days').format("DD/MM/YYYY"),
        endTime: dayjs().format("DD/MM/YYYY"),
        names: [],
        statusCodes: [],
        hours: [],
        hosts: [],
        methods: [],
    });

    useEffect(() => {

        let initialValues = Object.assign({}, whereCondition);

        const startTime = dayjs(initialValues.startTime, 'DD/MM/YYYY').isValid() ? dayjs(initialValues.startTime, 'DD/MM/YYYY') : null;
        const endTime = dayjs(initialValues.endTime, 'DD/MM/YYYY').isValid() ? dayjs(initialValues.endTime, 'DD/MM/YYYY') : null;

        initialValues['range-time'] = [startTime, endTime];

        form.setFieldsValue(initialValues);
    }, []);

    return (
        <div className="px-7">
            <div className="flex flex-col gap-5 p-7 card">
                <div className="flex items-center justify-items-center justify-between">
                    <div className="flex flex-col">
                        <h1>
                            <b>THỐNG KÊ TRUY CẬP API</b>
                        </h1>
                        {/* Backend chỉ thống kê GET/POST trên các tên miền của hệ thống và đã
                            loại lưu lượng rác (file tĩnh, bot quét). Nói rõ để không bị hiểu
                            là thiếu số liệu. */}
                        <Typography.Text type="secondary">
                            Số liệu chỉ tính request GET và POST tới các tên miền của Lịch Việt, đã loại file tĩnh và lưu lượng bot
                        </Typography.Text>
                    </div>

                    <div className="flex justify-content-end gap-3">
                        <Button
                            type="primary"
                            onClick={() => {
                                exportTableToExcelNew(dataExport, "BaoCaoTruyCapApi");
                            }}
                        >
                            Export
                        </Button>
                        <PopUpAddGraphical
                            metricId={10}
                            dimensionId={10}
                            addDataFields={values => {
                                const newValues = { ...values };
                                setGraphical(newValues);
                            }}
                        />
                    </div>
                </div>

                <RenderForm
                    onFinish={(values) => {
                        let dataQueries = {};

                        Object.keys(values).map(key => {
                            const item = values[key];
                            if (key == "range-time") {

                                const startTime = dayjs(item[0]).format('DD/MM/YYYY');
                                const endTime = dayjs(item[1]).format('DD/MM/YYYY');

                                dataQueries.startTime = startTime;
                                dataQueries.endTime = endTime;
                            } else if (key == "audienceIds") {
                                if (item) {
                                    dataQueries[key] = [item];
                                } else {
                                    dataQueries[key] = [];
                                }
                            } else {
                                if (item) {
                                    dataQueries[key] = item;
                                } else {
                                    dataQueries[key] = [];
                                }
                            }
                        })

                        setWhereCondition(dataQueries);
                    }}
                    form={form}
                    fields={setUpFormModal}
                    footer={<></>}
                />

                <BieuDo
                    metricId={10}
                    dimensionId={10}
                    whereCondition={whereCondition}
                    apiCallBack={getGraphicalTruyCapApi}
                    dataFields={[{ metricIds: [1], dimensionIds: [null] }]}
                    addGraphical={graphical}
                />

                <div className="flex w-full">
                    <Row className="w-full" justify="space-between" gutter={[10, 10]}>
                        <Col span={20}>
                            <TablePagination
                                apiCallBack={getDataTruyCapAPI}
                                whereCondition={whereCondition}
                                dataFields={tableFields}
                                dataTableChange={values => {
                                    setDataExport(values);
                                }}
                            />
                        </Col>
                        <Col span={4}>
                            <FillterTable
                                metricId={10}
                                dimensionId={10}
                                dataFields={tableFields}
                                onFieldsChange={values => {
                                    setTableFields(values)
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}